<template>
  <div>
    <v-card outlined @click="toggleEventDetailsDialog" height="100%">
      <v-card-title
        class="font-weight-medium text-left subtitle-2 pt-1 pb-0 px-2 d-block text-truncate"
      >
        {{ deadline.title }}
      </v-card-title>
      <v-card-subtitle class="text-left pt-3 px-2 pb-1">
        <span class="font-weight-medium subtitle-2 text--darken-4">
          {{ deadline.meta.dueDate }}
        </span>
        {{ deadline.shortTitle }}
      </v-card-subtitle>

      <!-- <v-card-text class="text-left px-2 pb-1"> </v-card-text> -->
    </v-card>
    <CustomDialog
      v-if="showEventDetailsDialog"
      @close="toggleEventDetailsDialog()"
      title="Details"
      fullscreenOnMobile
      width="s"
      showCloseBtn
      hideCloseBtn
      hideActionBtn
    >
      <template v-slot:content>
        <deadline-detail-card
          :deadline="deadline"
          outlined
        ></deadline-detail-card>
        <deadline-detail-counter-card
          :deadline="deadline"
          hideTitle
          outlined
          :deadlineEntries="deadlnieEntries"
          showDeadlineDistribution
          class="mt-4"
        ></deadline-detail-counter-card>
      </template>
    </CustomDialog>
  </div>
</template>

<script>
import CustomDialog from "@/components/_systemwide/CustomDialog.vue";
import DeadlineDetailCard from "@/components/member-management/deadlines/DeadlineDetailCard.vue";
import DeadlineDetailCounterCard from "@/components/member-management/deadlines/DeadlineDetailCounterCard.vue";
export default {
  name: "matrix-deadline-card",
  components: {
    CustomDialog,
    DeadlineDetailCard,
    DeadlineDetailCounterCard,
  },
  props: {
    deadline: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showEventDetailsDialog: false,
    };
  },
  methods: {
    toggleEventDetailsDialog() {
      this.showEventDetailsDialog = !this.showEventDetailsDialog;
    },
  },
};
</script>
